import { API_CONSTANT } from "../../services/ApiConstant";
import { postWithOutToken } from "../../services/ApiService";

export const loginApiCall = (data) => {
  return new Promise((resolve, reject) => {
    postWithOutToken(`${API_CONSTANT.LOGIN}`, data, false)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
